import { Outlet } from 'react-router-dom';

import { useAppSelector } from '@app/store/store';
import { ModalProvider } from '@contexts/modal-context/ModalContext';
import { selectIsAuthenticated } from '@features/authentication/store/authentication.slice';
import { useInactivityMonitor } from '@shared/utils/hooks/useInactivityMonitor';

const InactivityWatcher = () => {
  useInactivityMonitor();
  return null;
};

export const GlobalLayout = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  return (
    <ModalProvider sessionActive={isAuthenticated}>
      {isAuthenticated && <InactivityWatcher />}
      <Outlet />
    </ModalProvider>
  );
};
